import { render, staticRenderFns } from "./chatgpt.vue?vue&type=template&id=4c37a20e&scoped=true"
import script from "./chatgpt.vue?vue&type=script&lang=js"
export * from "./chatgpt.vue?vue&type=script&lang=js"
import style0 from "./chatgpt.vue?vue&type=style&index=0&id=4c37a20e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c37a20e",
  null
  
)

export default component.exports